// src/components/TrustPill.js
import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';
import VerifiedIcon from '@mui/icons-material/Verified';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/**
 * TrustPill — single, clickable capsule using a success green-tinted surface.
 * Uses attention-grabbing but professional green tones for "updated" messaging.
 */
const TrustPill = () => {
  return (
    <Box
      component={Link}
      to="/about-the-salary-calculator"
      aria-label="See what's changed in the 2025/26 HMRC figures"
      sx={(theme) => ({
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,                      // 8px
        px: 1.5,                     // 12px
        py: 0.75,                    // 6px
        borderRadius: 9999,          // full pill
        // Success green tinted surface + defined border
        backgroundColor: alpha(theme.palette.success.main, 0.12),
        border: '1px solid',
        borderColor: alpha(theme.palette.success.main, 0.4),
        textDecoration: 'none',
        color: theme.palette.success.dark,
        transition:
          'background-color 120ms ease, border-color 120ms ease, transform 120ms ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.success.main, 0.18),
          borderColor: alpha(theme.palette.success.main, 0.6),
          transform: 'translateY(-1px)',
          textDecoration: 'none',
        },
        '&:focus-visible': {
          outline: `2px solid ${theme.palette.success.main}`,
          outlineOffset: 2,
        },
      })}
    >
      <VerifiedIcon
        data-testid="VerifiedIcon"
        sx={{ color: 'success.main', fontSize: '1rem', flex: '0 0 auto' }}
        aria-hidden
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
          color: 'success.dark',
          fontSize: '0.75rem',
          letterSpacing: '0.02em',
          whiteSpace: 'nowrap',
        }}
      >
        Updated for 2025/26 — Latest HMRC figures
      </Typography>
      <ChevronRightIcon
        sx={{ fontSize: '1rem', color: 'success.main', flex: '0 0 auto' }}
        aria-hidden
      />
    </Box>
  );
};

export default TrustPill;
